/**
 * `useNotify` — the hook every form uses to raise a notification.  Returns the
 * shared {@link NotifyApi} (`success` / `error` / `warning` / `info` / `notify`).
 *
 * Must be called inside `<NotificationProvider>` (mounted once at the app root
 * in `main.tsx`).  See NotificationProvider for the behaviour contract.
 */
import { useContext } from 'react';
import { NotifyContext, type NotifyApi } from './NotificationProvider';

export function useNotify(): NotifyApi {
  const ctx = useContext(NotifyContext);
  if (!ctx) {
    throw new Error('useNotify must be used within <NotificationProvider> (mounted in main.tsx).');
  }
  return ctx;
}
